<button class="canvas-admin-main-button" [routerLink]="routerLink" [ngClass]="additionalClasses" (click)="onClick()" [disabled]="isDisabled">
  <ng-content></ng-content>
</button>
